import { createStyles } from '@mui/styles';
import { APTheme } from "../../../../core/TenantProvider/tenants";

export default (theme: APTheme) => createStyles({
  formControl: {
    marginBottom: 25,
    position: 'relative',
    '& .MuiSvgIcon-root': {
      fontSize: '2.4rem'
    },
    '& .MuiInputBase-input': {
      backgroundColor: '#ffffff',
    },
    '& .MuiInputBase-input.Mui-disabled': {
      color: '#4a4a4a',
      backgroundColor: '#f5f5f5',
      WebkitTextFillColor: '#4a4a4a'
    }
  },

  dobField: {
    '& label': {
      color: "rgba(0, 0, 0, 0.54) !important",
      backgroundColor: "#FFF",
      paddingRight: 10
    },
    '& div input': {
      color: "rgba(0, 0, 0, 0.87) !important",
    },
    '& label, & div input': {
      fontSize: "1.6rem",
      fontFamily: "CircularStd"
    },
    '& div div button span svg': {
      fontSize: "2.2rem"
    }
  },
  keyboardDatePicker: {
    display: "inline-grid",
  },
  helperText: {
    color: '#a4a4a4',
    fontSize: 12,
    marginTop: 5,
    marginLeft:0
  },
  stateIcon: {
    backgroundColor: '#FFF',
    borderRadius: 100,
    height: 20,
    padding: 0,
    position: 'absolute',
    right: -8,
    top: -8,
    width: 20
  },
  dateLabel: {
    color: "#FFF",
    fontSize: "2.4rem"
  },
  passwordEyeIcon: {
    right: 6,
    margin: 0,
    position: 'absolute',
    top: 6,
    height: 46,
    width: 46,
    zIndex: 1
  },
  passwordInputWrapper: {
    position: 'relative'
  }
});